import React, { useCallback, useState } from 'react';
import { MotionConfig } from 'framer-motion';

import { Collective } from './components/Collective';
import { Contact } from './components/Contact';
import { Cursor } from './components/Cursor';
import { Hero } from './components/Hero';
import { Loader } from './components/Loader';
import { Manifesto } from './components/Manifesto';
import { Marquee } from './components/Marquee';
import { Nav } from './components/Nav';
import { Now } from './components/Now';
import { Record } from './components/Record';
import { fields } from './content';
import { useSmoothScroll } from './hooks/useSmoothScroll';

import './styles/index.scss';

const SEEN_KEY = 'ib-intro-seen';

function shouldShowIntro() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  try {
    return sessionStorage.getItem(SEEN_KEY) !== '1';
  } catch {
    return true;
  }
}

const App: React.FC = () => {
  const [intro] = useState(shouldShowIntro);
  const [ready, setReady] = useState(!intro);
  useSmoothScroll();

  const finishIntro = useCallback(() => {
    try {
      sessionStorage.setItem(SEEN_KEY, '1');
    } catch {
      /* ignore */
    }
    setReady(true);
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      {intro && <Loader onDone={finishIntro} />}
      <Cursor />
      <Nav show={ready} />
      <main>
        <Hero show={ready} />
        <Marquee items={fields} />
        <Manifesto />
        <Now />
        <Collective />
        <Record />
      </main>
      <Contact />
    </MotionConfig>
  );
};

export default App;
